import React from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { FaClock, FaArrowLeft } from 'react-icons/fa';
import { getToken } from '../../../utils/auth';
import { getDashboardRoute } from '../../../utils/roleUtils';
import allSafeLogo from '../../../assets/cloudsafe-logo.png';
import './ComingSoon.css';

const ComingSoon = ({ featureName: propFeatureName }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const featureName = propFeatureName || searchParams.get('feature') || searchParams.get('name');
  const isLoggedIn = !!getToken();

  const primaryLink = isLoggedIn ? getDashboardRoute() : '/login';
  const primaryLabel = isLoggedIn ? 'Back to dashboard' : 'Back to login';

  return (
    <div className="csoon-page">
      <header className="csoon-header">
        <img src={allSafeLogo} alt="CloudSafe" className="csoon-logo" />
        <div className="csoon-header-right">
          {isLoggedIn ? (
            <Link to={getDashboardRoute()} className="csoon-header-link">Dashboard</Link>
          ) : (
            <Link to="/login" className="csoon-header-link">Sign in</Link>
          )}
        </div>
      </header>

      <main className="csoon-body">
        <div className="csoon-card">
          <div className="csoon-icon-wrap">
            <FaClock className="csoon-icon" />
          </div>
          <h1 className="csoon-title">Coming soon</h1>
          <p className="csoon-subtitle">
            {featureName
              ? `${featureName} is currently under development and will be available soon.`
              : 'This feature is under development and will be available soon.'}
          </p>

          <Link to={primaryLink} className="csoon-submit">
            {primaryLabel}
          </Link>

          {isLoggedIn ? (
            <button
              type="button"
              className="csoon-back-link"
              onClick={() => navigate(-1)}
            >
              <FaArrowLeft /> Go back
            </button>
          ) : (
            <Link to="/" className="csoon-back-link">
              <FaArrowLeft /> Return home
            </Link>
          )}
        </div>
      </main>
    </div>
  );
};

export default ComingSoon;
